import { render } from "./evalDetail-data.vue?vue&type=template&id=56473fc2&scoped=true"
import script from "./evalDetail-data.vue?vue&type=script&lang=js"
export * from "./evalDetail-data.vue?vue&type=script&lang=js"

import "./evalDetail-data.vue?vue&type=style&index=0&id=56473fc2&scoped=true&lang=scss"

import exportComponent from "/root/workspace/interactive-system-pc_dBxe/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56473fc2"]])

export default __exports__